import { firestoreAction } from 'vuexfire'
import {db} from '@/firebase'

const products = db.collection('products')
const product_variations = db.collection('product_variations')
const product_specifications = db.collection('product_specifications')
const services = db.collection('services')
const subservices = db.collection('subservices')
const events = db.collection('events')
const event_variations = db.collection('event_variations')

const state = {
  //
  categories: [],
    //
  subcategory_products: [],
  products: [],
  product_variations: [],
    //
  subcategory_services: [],
  services: [],
  subservices: [],
    //
  submonth_events: [],
  events: [],
  event_variations: [],
  event_planners: [],
    //
  subcategory_supplies: [],
  supplies: [],
  supply_variations: [],
    //
  product_images: [],
  product_specifications: []
}

const getters = {
  category: state => (
    state.categories[0] ? state.categories[0] : {}
  ),
  subcategoryprdct: state => (
    state.subcategory_products[0] ? state.subcategory_products[0] : {}
  ),
  prdct: state => (
    state.products[0] ? state.products[0] : {}
  ),
  subcategoryserv: state => (
    state.subcategory_services[0] ? state.subcategory_services[0] : {}
  ),
  serv: state => (
    state.services[0] ? state.services[0] : {}
  ),
  subcategorysup: state => (
    state.subcategory_supplies[0] ? state.subcategory_supplies[0] : {}
  ),
  supli: state => (
    state.supplies[0] ? state.supplies[0] : {}
  ),
  product_image: state => (
    state.product_images[0] ? state.product_images[0] : {}
  ),
  submonthevent: state => (
    state.submonth_events[0] ? state.submonth_events[0] : {}
  ),
  even: state => (
    state.events[0] ? state.events[0] : {}
  )
}

const actions = {
  initCategory: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('categories', db.collection('categories').where('slug', '==', slug))
  }),
  initSerSubCategory: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('subcategory_services', db.collection('subcategory_services').where('slug', '==', slug))
  }),
  initPrdtSubCategory: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('subcategory_products', db.collection('subcategory_products').where('slug', '==', slug))
  }),
  initEvenSubMonth: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('submonth_events', db.collection('submonth_events').where('slug', '==', slug))
  }),
  initSupSubCategory: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('subcategory_supplies', db.collection('subcategory_supplies').where('slug', '==', slug))
  }),
  initProducts: firestoreAction(({ bindFirestoreRef }, SubCat_pid) => {
    bindFirestoreRef('products', products.where('SubCat_pid', '==', SubCat_pid))
  }),
  initProducto: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('products', db.collection('products').where('slug', '==', slug))
  }),
  initProductVariations: firestoreAction(({ bindFirestoreRef }, p_id) => {
    bindFirestoreRef('product_variations', product_variations.where('p_id', '==', p_id))
  }),
  initProductImg: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('product_images', db.collection('product_images').where('slug', '==', slug))
  }),
  initProductSpecifications: firestoreAction(({ bindFirestoreRef }, pimg_id) => {
    bindFirestoreRef('product_specifications', product_specifications.where('pimg_id', '==', pimg_id))
  }),
  initServices: firestoreAction(({ bindFirestoreRef }, SubCat_sid) => {
    bindFirestoreRef('services', services.where('SubCat_sid', '==', SubCat_sid))
  }),
  initServico: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('services', db.collection('services').where('slug', '==', slug))
  }),
  initSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices', subservices.where('s_id', '==', s_id))
  }),
  initEvents: firestoreAction(({ bindFirestoreRef }, SubCat_eid) => {
    bindFirestoreRef('events', events.where('SubCat_eid', '==', SubCat_eid))
  }),
  initEvento: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('events', db.collection('events').where('slug', '==', slug))
  }),
  initEventVariations: firestoreAction(({ bindFirestoreRef }, e_id) => {
    bindFirestoreRef('event_variations', event_variations.where('e_id', '==', e_id))
  }),
  // Pin point line
  initProducta: firestoreAction(({ bindFirestoreRef }, Cat_pid) => {
    bindFirestoreRef('products', products.where('Cat_pid', '==', Cat_pid))
  }),
  initSuProducta: firestoreAction(({ bindFirestoreRef }, SubCat_pid) => {
    bindFirestoreRef('products', products.where('SubCat_pid', '==', SubCat_pid))
  }),
  initEvente: firestoreAction(({ bindFirestoreRef }, Cat_eid) => {
    bindFirestoreRef('events', events.where('Cat_eid', '==', Cat_eid))
  }),
  initSuEvente: firestoreAction(({ bindFirestoreRef }, SubCat_eid) => {
    bindFirestoreRef('events', events.where('SubCat_eid', '==', SubCat_eid))
  }),
  initServica: firestoreAction(({ bindFirestoreRef }, Cat_sid) => {
    bindFirestoreRef('services', services.where('Cat_sid', '==', Cat_sid))
  }),
  initSuServica: firestoreAction(({ bindFirestoreRef }, SubCat_sid) => {
    bindFirestoreRef('services', services.where('SubCat_sid', '==', SubCat_sid))
  }),
}

export default {
  namespaced: true,
  state,
  actions,
  getters
}

